module.exports = __webpack_public_path__ + "static/media/34DSS6.0d75f32b.jpg";